module.exports = require('./helpers/bundle-url').getBundleURL('20yJn') + "logo-dark.ba5147f0.svg";